import React, { createContext, useContext, useEffect, useState } from "react";
import api from "./api";

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(() => {
    const stored = localStorage.getItem("mfd_user");
    return stored ? JSON.parse(stored) : null;
  });
  const [loading, setLoading] = useState(false);

  const login = async (email, password) => {
    const { data } = await api.post("/auth/login", { email, password });
    localStorage.setItem("mfd_token", data.token);
    localStorage.setItem("mfd_user", JSON.stringify(data.user));
    setUser(data.user);
    return data.user;
  };

  // Called by the ChangePassword page after a successful update so the
  // must_change_password flag flips off without needing a full re-login.
  const refreshUser = async () => {
    try {
      const { data } = await api.get("/auth/me");
      const u = { id: data.id, name: data.name, email: data.email, role: data.role, must_change_password: !!data.must_change_password };
      localStorage.setItem("mfd_user", JSON.stringify(u));
      setUser(u);
      return u;
    } catch { /* silent */ }
  };

  const logout = () => {
    localStorage.removeItem("mfd_token");
    localStorage.removeItem("mfd_user");
    setUser(null);
    window.location.href = "/login";
  };

  return (
    <AuthContext.Provider value={{ user, login, logout, loading, setLoading, refreshUser }}>
      {children}
    </AuthContext.Provider>
  );
}

export const useAuth = () => useContext(AuthContext);
